/**
 * Exercise Data Structure - FIXED VERSION
 *
 * All exercise names now match the actual video files in your folder
 * Fixed naming inconsistencies and added missing exercises
 *
 * Muscle group codes:
 * ~ = legs, w = chest, @ = back, d = core, ^ = arms, _ = shoulders
 */

export const advancedBodyWeightmixOptions = {
    // Basic bodyweight exercises by muscle group
    "~": ["AirSquats", "Lunges", "StepUps", "CalfRaises"],
    "w": ["PushUps", "DiamondPushUps", "PikePushUps"],
    "@": ["PullUps", "ChinUps", "AustralianPullUps"],
    "d": ["Plank", "RussianTwists", "MountainClimbers"],
    "^": ["PushUps", "DiamondPushUps", "PikePushUps", "TricepDips"],
    "_": ["PikePushUps", "ElevatedPushUps", "Plank"],

    // Advanced bodyweight exercises by specific muscle group
    "l": ["G87DeadLift", "G87WideGripBandSquat", "G87WideGripDeadLift"],     // legband
    "c": ["TriangleFloorBenchPress", "G87DoorSmash", "TriangleOverheadPress", "TriangleWideFly", "TriangleTorso"], // chestband
    "b": ["G87BentRow", "G87FlyBack", "TriangleOneArmRow", "G87SuperWideChop", "G87WideGripBentRow"], // coreband
    "o": ["TriangleFloorCrusher", "TriangleJet", "TriangleLiftAndPunch", "TriangleLiftOff", "TriangleOneArmTwist", "TrianglePunchDefend", "TriangleUpsideDownPull"], // armband
    "r": ["G87ReverseCurl", "G87OneArmPunch", "G87WideGripReverseCurl", "G87WideStraightBarCurl", "G87SeatedFrenchPress", "TriangleSlowCurl", "TriangleTiltAndPour", "G87ReverseWristCurl"], // shoulderband
    "s": ["G87WideGripOneArmFrontRaise", "G87StepWide", "G87OneArmOverheadPress", "TriangleOneArmFrontRaise", "TriangleOneArmSwing", "TriangleFrontRaise", "G87WideGripDoorSmash", "TriangleRocket", "TriangleWings", "TriangleUprightRow"],

    // Chest exercises
    "e": [
        "ClappingPushUps",
        "DeclinePushUps",
        "DiveBombers",
        "HandReleasePushUps",
        "PushUpsClose",
        "PushUpsWide",
        "PushUpsSpiderman",
        "SpartanPushUps",
        "SlowPushUps",
        "TPushUps",
        "StaggeredArmPushUps",
        "InchwormPushUps",
        "PendulumPushUps",
        "PancakePushUps",
        "RockingHorsePushUps",
        "SpidermanWalkingPushUps",
        "SwissBallPushUps"
    ],

    // Back exercises
    "k": [
        "BackExtensions",
        "ChinUps",
        "ChinUpsOneArmLeft",
        "ChinUpsOneArmRight", // Fixed naming
        "DoubleDumbbellRows",
        "DumbbellRows",
        "ExplosiveRows",
        "InvertedRowsWithChairs",
        "NegativePullUps",
        "PullUpsBarHold",
        "BentOverRows",
        "TBarRows",
        "SeatedCableRows",
        "Hyperextensions"
    ],

    // Shoulder exercises
    "h": [
        "DumbbellJumpSquats",
        "DumbbellSquatsAndPress", // Fixed naming to match video
        "HandstandPushUps",
        "OverheadSquatWithDumbbells",
        "PushUpJumps",
        "MilitaryPress",
        "ArnoldPress",
        "LateralRaises",
        "FrontRaises",
        "RearDeltFlyes",
        "ShoulderPress",
        "ShoulderToFloorStretch",
        "SmallToLargeArmCircles",
        "WallWalkouts"
    ],

    // Arm exercises
    "m": [
        "BenchOrChairDips",
        "BicepCurls",
        "BicepCurls2",
        "ChairTricepExtension",
        "Dips",
        "DipsHoldBottom",
        "DipsX", // Added missing exercise
        "DumbbellKickbacks", // Fixed naming
        "FrontRackStretch",
        "TricepPress",
        "TricepDips",
        "TricepExtensions",
        "HammerCurls",
        "PreacherCurls",
        "SkullCrushers"
    ],

    // Bicep exercises
    "i": [
        "BicepCurls",
        "BicepCurls2",
        "HammerCurls",
        "PreacherCurls",
        "PullUpsBarHold"
    ],

    // Tricep exercises
    "t": [
        "BenchOrChairDips",
        "ChairTricepExtension",
        "Dips",
        "DipsHoldBottom",
        "DipsX",
        "DumbbellKickbacks", // Fixed naming
        "TricepPress",
        "TricepDips",
        "TricepExtensions",
        "SkullCrushers"
    ],

    // Forearm exercises
    "f": [
        "FarmerSquats",
        "WristCurls",
        "ReverseWristCurls",
        "FarmersWalks",
        "DumbbellFarmersWalk"
    ],

    // Ab exercises - COMPLETE LIST
    "a": [
        "AbsInAndOut",
        "AbScissors",
        "AbsCrunchesDumbbells",
        "AbsCrunchesDumbbellsLegs",
        "BicycleCrunches",
        "BicycleCrunch", // Added missing variation
        "BicycleCrunchesLegsLower",
        "CrunchAndPunch",
        "Crunches",
        "Crunches2", // Added missing variation
        "CrossLeggedSeatedRaises",
        "DeadBugs",
        "FeetStackedCrunches",
        "FullLegRaises",
        "HangingLegRaises",
        "HipRaiseHold",
        "HipRaises",
        "HipRaisesLeft",
        "HipRaisesRight",
        "HollowHold",
        "HollowHoldToSuperman",
        "HollowRocks",
        "HollowRocksWithDumbbells",
        "IsolatedCrunchesLeftAndRight",
        "KneeKicks",
        "KneePlank", // Fixed naming
        "KneesToElbows",
        "LeftIsolatedCrunches",
        "LegRaises",
        "LegRaises2", // Added missing variation
        "LowLegRaiseHold",
        "LowLegRaises",
        "LSitHoldFromPullUpBar",
        "MountainClimbers",
        "MountainClimbers2", // Added missing variation
        "ObliqueTwistLeftAndRight",
        "Plank",
        "Plank2", // Added missing variation
        "PlankPushUps",
        "PlankToPushUp",
        "PlankTricepsExtension",
        "PlankVariations",
        "PullUpBarCrunches",
        "PushUpsHillClimbers",
        "PushUpTwistKick",
        "RightIsolatedCrunches",
        "RussianTwists",
        "ScissorTwist",
        "SeatedCrunches",
        "SeatedLegCircles",
        "SeatedLegScissors",
        "SeatedTwist",
        "SeatedTwistsLegsElevated",
        "ShinTouches",
        "SideObliquesTwistLeftRight",
        "SidePlank",
        "SidePlankLeft",
        "SidePlankRaiseRight",
        "SidePlankThrusts",
        "SitThrusts",
        "SphinxPushUps",
        "SpidermanPlanks",
        "StraightArmPlankKneesToElbows",
        "SupermanRocks",
        "SwissBallVups",
        "TickTocks",
        "ToeTouches",
        "ToesToBar", // Added missing exercise
        "Twisters",
        "UpperBodyHollowHoldKnee",
        "UpperLegRaise",
        "Vups",
        "CableCrunches",
        "AbRollouts"
    ],

    // Leg exercises - COMPLETE LIST
    "g": [
        "AdvancedBoxJumps",
        "AirSquats",
        "AlternatingLungesWithDumbbells",
        "BoxJumps",
        "BroadSkaterJumps",
        "BurpeeWithDumbbell",
        "CalfRaises",
        "DonkeyCalfRaises",
        "CalfPressOnLegPressMachine",
        "Deadlift", // Fixed naming to match video
        "DeadLift", // Alternative naming
        "Deadlifts", // Alternative naming
        "DumbbellJumpSquats",
        "DumbbellReverseLunges",
        "DumbbellSquats",
        "DumbbellSquatsAndPress", // Fixed naming
        "DumbbellThruster",
        "FarmerSquats",
        "GluteBridges",
        "HipThrusts",
        "HipThrust", // Alternative naming
        "JumpSquats",
        "JumpSquats180", // Added missing variation
        "JumpingLunges",
        "LegCurls",
        "LegExtensions",
        "LegPress",
        "Lunges",
        "Lunges2", // Added missing variation
        "PistolSquatsBeginner",
        "PistolSquats",
        "PrisonerSquats",
        "ReverseLunges",
        "ShortJumps",
        "SideToSideJumps",
        "SideToSideSkaterJumps",
        "SkaterJumpsWithGroundTouch",
        "Squats",
        "SquatAndPressWithDumbbells",
        "StepBackLunges",
        "StepUps",
        "StepUps2", // Added missing variation
        "StiffLeggedDeadlift",
        "SumoSquats",
        "SumoWalks",
        "TuckJumps", // Added missing exercise
        "WallSit", // Added missing exercise
        "WarriorIII"
    ],

    // Calves exercises
    "v": [
        "CalfRaises",
        "DonkeyCalfRaises",
        "CalfPressOnLegPressMachine",
        "JumpSquats",
        "JumpingLunges",
        "ShortJumps"
    ],

    // Trap exercises
    "p": [
        "FarmerSquats",
        "Shrugs",
        "UprightRows",
        "DumbbellFarmersWalk"
    ],

    // Quad exercises
    "q": [
        "AirSquats",
        "AlternatingLungesWithDumbbells",
        "DumbbellSquats",
        "DumbbellSquatsAndPress", // Fixed naming
        "JumpSquats",
        "JumpingLunges",
        "LegExtensions",
        "LegPress",
        "Lunges",
        "PistolSquatsBeginner",
        "PistolSquats",
        "PrisonerSquats",
        "ReverseLunges",
        "Squats",
        "SquatAndPressWithDumbbells",
        "StepBackLunges",
        "SumoSquats"
    ],

    // Hamstring exercises
    "n": [
        "Deadlift", // Fixed naming
        "DeadLift",
        "Deadlifts",
        "LegCurls",
        "StiffLeggedDeadlift"
    ],

    // Glute exercises
    "u": [
        "Deadlift", // Fixed naming
        "DeadLift",
        "Deadlifts",
        "GluteBridges",
        "HipRaiseHold",
        "HipRaises",
        "HipRaisesLeft",
        "HipRaisesRight",
        "HipThrusts",
        "HipThrust",
        "StiffLeggedDeadlift"
    ],

    // Hip exercises
    "j": [
        "HipAbductionMachine",
        "HipAdductionMachine",
        "ClamshellExercise",
        "HipRaiseHold",
        "HipRaises",
        "HipRaisesLeft",
        "HipRaisesRight",
        "HipThrusts",
        "HipTouches"
    ],

    // Thigh exercises
    "y": [
        "AlternatingLungesWithDumbbells",
        "DumbbellReverseLunges",
        "DumbbellSquats",
        "JumpingLunges",
        "Lunges",
        "PistolSquatsBeginner",
        "PistolSquats",
        "ReverseLunges",
        "StepBackLunges",
        "SumoSquats"
    ],

    // Oblique exercises
    "z": [
        "BicycleCrunches",
        "ObliqueTwistLeftAndRight",
        "RussianDumbbellSwing",
        "RussianTwists",
        "SeatedTwist",
        "SeatedTwistsLegsElevated",
        "SidePlank",
        "SidePlankLeft",
        "SidePlankRaiseRight",
        "SidePlankThrusts",
        "SideObliquesTwistLeftRight"
    ],

    // Overall/Full Body exercises
    "!": [
        "BurpeePlusHillClimbers",
        "BurpeePlusPushUpAndPress",
        "BurpeeWithDumbbell",
        "Deadlift", // Fixed naming
        "DeadLift",
        "DumbbellSquatsAndPress", // Fixed naming
        "OneArmBurpees",
        "PushUpsSpiderman",
        "Sprawls",
        "DumbbellThruster"
    ],

    // Chest gym exercises
    "$": [
        "BenchPress",
        "DumbbellFlyes",
        "CableCrossovers",
        "ChestPressMachine",
        "PushUpsWeighted",
        "PecDeckMachine"
    ],

    // Back gym exercises
    "x": [
        "PullUps",
        "BentOverRows",
        "TBarRows",
        "SeatedCableRows",
        "SeatedCableRow", // Alternative naming
        "LatPulldowns",
        "Deadlifts",
        "Deadlift", // Alternative naming
        "Hyperextensions",
        "Hyperextension" // Alternative naming
    ],

    // Shoulder gym exercises
    "&": [
        "MilitaryPress",
        "ArnoldPress",
        "LateralRaises",
        "FrontRaises",
        "RearDeltFlyes",
        "RearDeltFlys", // Alternative naming
        "ShoulderPress",
        "Shrugs"
    ],

    // Arm gym exercises
    "*": [
        "BicepCurls",
        "BicepCurls2",
        "HammerCurls",
        "PreacherCurls",
        "TricepExtensions",
        "TricepDips",
        "SkullCrushers"
    ],

    // Bicep gym exercises
    "(": [
        "BicepCurls",
        "BicepCurls2",
        "HammerCurls",
        "PreacherCurls"
    ],

    // Tricep gym exercises
    ")": [
        "TricepExtensions",
        "TricepDips",
        "SkullCrushers"
    ],

    // Forearm gym exercises
    "-": [
        "WristCurls",
        "ReverseWristCurls",
        "FarmersWalks",
        "DumbbellFarmersWalk"
    ],

    // Ab gym exercises
    "+": [
        "Crunches2",
        "RussianTwists",
        "PlankVariations",
        "LegRaises",
        "CableCrunches",
        "AbRollouts"
    ],

    // Leg gym exercises
    "=": [
        "Squats",
        "LegPress",
        "Lunges",
        "LegExtensions",
        "LegCurls",
        "CalfRaises"
    ],

    // Quad gym exercises
    "[": [
        "Squats",
        "LegPress",
        "LegExtensions"
    ],

    // Hamstring gym exercises
    "]": [
        "Deadlifts",
        "Deadlift", // Alternative naming
        "LegCurls"
    ],

    // Glute gym exercises
    "{": [
        "HipThrusts",
        "HipThrust", // Alternative naming
        "GluteBridges",
        "Deadlifts",
        "Deadlift" // Alternative naming
    ],

    // Calf gym exercises
    "}": [
        "CalfRaises",
        "DonkeyCalfRaises",
        "CalfPressOnLegPressMachine"
    ],

    // Trap gym exercises
    ":": [
        "Shrugs",
        "UprightRows",
        "DumbbellFarmersWalk"
    ],

    // Oblique gym exercises
    ";": [
        "RussianTwists",
        "SidePlank",
        "BicycleCrunches"
    ],

    // Hip gym exercises
    "|": [
        "HipAbductionMachine",
        "HipAdductionMachine",
        "ClamshellExercise"
    ],

    // Thigh gym exercises
    "<": [
        "Squats",
        "LegPress",
        "LegExtensions",
        "LegCurls",
        "Lunges"
    ],

    // Overall gym exercises
    ">": [
        "Deadlifts",
        "Deadlift", // Alternative naming
        "Squats",
        "BenchPress",
        "MilitaryPress",
        "PullUps"
    ]
};

/**
 * Maps muscle group codes to human-readable names
 */
export const muscleGroupNames = {
    "~": "Legs",
    "w": "Chest",
    "@": "Back",
    "d": "Core",
    "^": "Arms",
    "_": "Shoulders",
    "l": "Leg Bands",
    "c": "Chest Bands",
    "b": "Core Bands",
    "o": "Arm Bands",
    "r": "Shoulder Bands",
    "s": "Shoulder Bands+",
    "e": "Chest Advanced",
    "k": "Back Advanced",
    "h": "Shoulder Advanced",
    "m": "Arm Advanced",
    "i": "Biceps",
    "t": "Triceps",
    "f": "Forearms",
    "a": "Abs",
    "g": "Legs Advanced",
    "v": "Calves",
    "p": "Traps",
    "q": "Quads",
    "n": "Hamstrings",
    "u": "Glutes",
    "j": "Hips",
    "y": "Thighs",
    "z": "Obliques",
    "!": "Full Body",
    "$": "Chest Gym",
    "x": "Back Gym",
    "&": "Shoulder Gym",
    "*": "Arm Gym",
    "(": "Bicep Gym",
    ")": "Tricep Gym",
    "-": "Forearm Gym",
    "+": "Ab Gym",
    "=": "Leg Gym",
    "[": "Quad Gym",
    "]": "Hamstring Gym",
    "{": "Glute Gym",
    "}": "Calf Gym",
    ":": "Trap Gym",
    ";": "Oblique Gym",
    "|": "Hip Gym",
    "<": "Thigh Gym",
    ">": "Overall Gym"
};

/**
 * Sample predefined workout configurations
 */
export const sampleWorkouts = [
    { code: "~w@d^_", name: "Full Body Workout" },
    { code: "_^d@", name: "Upper Body Focus" },
    { code: "@_@_", name: "Back & Shoulders" },
    { code: "wd^^dw", name: "Chest & Arms" },
    { code: "^d^^", name: "Arms & Core" },
    { code: "wd_wd", name: "Chest, Core & Shoulders" },
    { code: "d_^dd@", name: "Core, Arms & Back" },
    { code: "@d_@d_", name: "Back, Core & Shoulders Circuit" },
    { code: "w_w_@", name: "Push-Pull" }
];

/**
 * Helper function to parse muscle group code and count
 * @param {string} input - A single character or character with count
 * @returns {Object} - Contains bodyPart and count
 */
export function parseBodyPartAndCount(input) {
    const bodyPart = input.charAt(0);
    const count = input.length > 1 ? parseInt(input.substring(1)) : 1;
    return { bodyPart, count: isNaN(count) ? 1 : count };
}

/**
 * Generate a workout based on muscle group codes
 * @param {string} muscleGroups - String of muscle group codes
 * @returns {Array} - List of exercises
 */
export function generateWorkout(muscleGroups) {
    const result = [];
    const options = muscleGroups.split('');

    options.forEach(option => {
        const { bodyPart, count } = parseBodyPartAndCount(option);
        const exercises = advancedBodyWeightmixOptions[bodyPart];

        if (exercises) {
            // Shuffle the exercises and take 'count' number of them
            const shuffled = [...exercises].sort(() => 0.5 - Math.random());
            const selected = shuffled.slice(0, count);
            result.push(...selected);
        }
    });

    return result;
}